import { createStore, applyMiddleware } from 'redux';
import reducers from '../reducers/Modal';
import ModalMiddleware from '../middleware/Modal';

function reduxStore(initialState, emitter) {
    const modal = new ModalMiddleware(emitter);
    const createStoreWithMiddleware = applyMiddleware(modal.modalEvent)(
        createStore
    );

    const store = createStoreWithMiddleware(
        reducers,
        initialState,
        window.devToolsExtension && window.devToolsExtension()
    );

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/Modal', () => {
            // We need to require for hot reloadign to work properly.
            const nextReducer = require('../reducers/Modal'); // eslint-disable-line global-require

            store.replaceReducer(nextReducer);
        });
    }

    return store;
}

export default reduxStore;



// WEBPACK FOOTER //
// ./stores/Modal.js